;(function () {

  window.Ateed.Components.HeaderMicro.MenuHelperMicro = function() {
    var self = this;
    var data = createTree();
    self.tree = data;
  };

  var createTree = function() {
    var tree = [];
    traverse($('.ateed-dormant-navigation-micro').find('> li'), tree);
    function traverse($lis, parent) {
      $lis.each(function() {
        var $li = $(this);
        var $a = $li.find('> a');
        var node = {
          uri: $a.attr('href'),
          title: $a.text().trim(),
          isActive: $a.attr('href') === window.location.pathname,
          isVisible: true
        };
        parent.push(node);
      });
    }
    return tree;
  }
})();
